//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  const svgCache = {};

    // This directive is meant for usage with dev-sourced SVGs.
    // As such, right now it only supports single-SVG files from root-relative paths
    // (e.g. /images/my-svg.svg)
    // If you want to use it to support arbitrary URLs for SVGs, you should consider security as you enable those URLs.
  curalate.directive('svgIcon', [
    '$http',
    '$templateCache',
    '$log',
    '$q',
    '$sce',
    function(
            $http,
            $templateCache,
            $log,
            $q,
            $sce,
        ) {
      const loadByUrl = function(url) {
        if (svgCache.hasOwnProperty(url)) {
          return $q.resolve(svgCache[url].cloneNode(true));
        }

        return $http
                    .get(url, { cache: $templateCache })
                    .then((response) => {
                      const svg = angular.element('<div>').append(response.data).find('svg')[0];
                      svgCache[url] = svg;
                      return svg.cloneNode(true);
                    }).catch((err) => {
                      const msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
                      $log.warn(msg);

                      return $q.reject(msg);
                    });
      };

      return {
        restrict: 'E',
        link(scope, elm, attrs) {
          const src = $sce.getTrustedResourceUrl(attrs.src);

          const svgName = /\/([^./]+)(\.[a-f0-9]+)?\.svg$/.exec(attrs.src)[1]; // Match just the name part of the filename

          elm.addClass(`svg-icon-${svgName}`); // Add a class based on the svg filename.

          loadByUrl(src).then((e) => {
            elm.html(e);


                        // The following comments and lines are adapted from svg-injector, which is under the MIT License.
                        // :WORKAROUND:
                        // IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
                        // This trick will trigger IE to read and use any existing SVG <style> tags.
                        //
                        // Reference: https://github.com/iconic/SVGInjector/issues/23
            Array.prototype.forEach.call(elm[0].querySelectorAll('style'), (styleTag) => {
              styleTag.textContent += '';
            });
          });
        },
      };
    },
  ]);
})();
